import { render, staticRenderFns } from "./AdminTabs.vue?vue&type=template&id=36c65804&scoped=true&"
import script from "./AdminTabs.vue?vue&type=script&lang=ts&"
export * from "./AdminTabs.vue?vue&type=script&lang=ts&"
import style0 from "./AdminTabs.vue?vue&type=style&index=0&id=36c65804&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c65804",
  null
  
)

export default component.exports